import {
  USER_LICENSE_ENTRY_KEYS,
  type UserLicenseEntry,
} from './user-licenses';

/**
 * One of the signed-in user's active licenses, as returned by
 * `GET /tessa/my-licenses`. It is the same row as the privileged entity route
 * returns, so both routes share one type and one key list.
 */
export type CurrentUserLicense = UserLicenseEntry;

export type TessaCurrentUserLicensesMode = 'disabled' | 'dummy' | 'live';

export interface TessaCurrentUserLicensesModeResponse {
  mode: TessaCurrentUserLicensesMode;
}

export const TESSA_CURRENT_USER_LICENSES_ROUTE_PATH = '/tessa/my-licenses';
export const TESSA_CURRENT_USER_LICENSES_MODE_ROUTE_PATH =
  '/tessa/my-licenses/mode';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isCurrentUserLicense(
  value: unknown,
): value is CurrentUserLicense {
  if (!isRecord(value)) return false;

  const keys = Object.keys(value);
  return (
    keys.length === USER_LICENSE_ENTRY_KEYS.length &&
    USER_LICENSE_ENTRY_KEYS.every(key => {
      const field = value[key];
      return typeof field === 'string' && field.trim().length > 0;
    })
  );
}

export function isCurrentUserLicenses(
  value: unknown,
): value is CurrentUserLicense[] {
  return Array.isArray(value) && value.every(isCurrentUserLicense);
}

export function isTessaCurrentUserLicensesModeResponse(
  value: unknown,
): value is TessaCurrentUserLicensesModeResponse {
  if (!isRecord(value) || Object.keys(value).length !== 1) return false;
  return (
    value.mode === 'disabled' || value.mode === 'dummy' || value.mode === 'live'
  );
}
